export default __webpack_public_path__ + "static/media/bag.01442015.png";